import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NarvarFooter from '@narvar/nth-narvar-footer';
import { PRIVACY_LINKS, TERMS_OF_USE_LINKS } from '../../constants/footerLinks';

const mapStateToProps = ({
  page: { productType, languageCode } = {},
  retailerSettings: { name: retailerName } = {},
  language: {
    'returns.validate.footer.terms_of_use': termsLinkText,
    'returns.validate.footer.privacy_policy': privacyLinkText,
    'returns.validate.footer.terms_of_use_link': termsLink,
    'returns.validate.footer.privacy_policy_link': privacyLink,
  } = {},
}) => ({
  productType,
  retailerName,
  languageCode,
  termsLinkText,
  privacyLinkText,
  termsLink,
  privacyLink,
});

const ReturnsNarvarFooter = ({
  productType,
  retailerName,
  languageCode,
  termsLinkText,
  privacyLinkText,
  termsLink,
  privacyLink,
}) => (
  <NarvarFooter
    footerStyle={{ margin: 0 }}
    logoHref={`https://corp.narvar.com/survey?product=${productType}&retailer_name=${retailerName}`}
    links={[
      {
        text: termsLinkText,
        href: termsLink || TERMS_OF_USE_LINKS[languageCode] || TERMS_OF_USE_LINKS.en,
      },
      {
        text: privacyLinkText,
        href: privacyLink || PRIVACY_LINKS[languageCode] || PRIVACY_LINKS.en,
      },
    ]}
  />
);

ReturnsNarvarFooter.defaultProps = {
  termsLinkText: 'Terms of Use',
  privacyLinkText: 'Privacy Policy',
  termsLink: '',
  privacyLink: '',
  languageCode: 'en',
};

ReturnsNarvarFooter.propTypes = {
  productType: PropTypes.string.isRequired,
  retailerName: PropTypes.string.isRequired,
  termsLinkText: PropTypes.string,
  privacyLinkText: PropTypes.string,
  termsLink: PropTypes.string,
  privacyLink: PropTypes.string,
  languageCode: PropTypes.string,
};

export default connect(mapStateToProps)(ReturnsNarvarFooter);
